import React, { useContext } from 'react'
import { FeatureFlagsContext } from 'utils/context/FeatureFlagsContext'
import { SHIPPER_RATES_COLUMNS } from 'apps/rms/types/shipperRates'
import { TableHead, TableRow, TableCell } from 'transfix-ui'

export const ShipperRateHistoryTableHeader = () => {
  const { getFlag } = useContext(FeatureFlagsContext)
  const { enabled: mpRmsRepricedRates } = getFlag('mpRmsRepricedRates')
  return (
    <TableHead>
      <TableRow tableCellType='th'>
        {Object.entries(SHIPPER_RATES_COLUMNS)
          .filter(
            ([, value]) => value !== SHIPPER_RATES_COLUMNS.isRepricedRate || mpRmsRepricedRates
          )
          .map(([key, value]) => (
            <TableCell dataTest={`${key}-rate-history-column-header`} key={`${key}-column-header`}>
              {value}
            </TableCell>
          ))}
        <TableCell>&nbsp;</TableCell>
      </TableRow>
    </TableHead>
  )
}
